import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

/* ========================== STATE ============================ */
const state = {
  // for drags of items
  drag_item: null,
  drag_item_type: null,
  drag_target_date: null,
  drag_target_index: null,
  // drag_time_active: false,

  // for drags of time handles
  drag_active: false,
  drag_time_active: false,
  drag_time_selection: null, // ok
  drag_time_offset: 0, // ok

  snapshot_stack: [], // TODO
  snapshot_stack_redo: [],

  show_backlog_list: {},

  view_selected: null,
  view_from: null,
  view_to: null,

  commitment_data_cache: null,
  commitment_data_hash: "",

  show_reduced_dayplan: false,
  show_nothing_planned: true,   // TODO: Save to db!
  column_layout: false,

  // TODO: selected tab
  // TODO: selected goal
  // TODO: selected commitment
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
